import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useOrganizationStore } from '@/core/stores/organization.store';
import { timeOffService } from '../api/time-off.service';
import { TIME_OFF_KEYS } from './queryKeys';
import type { OverrideTimeOffRequestPayload } from '../types';

/** Owner/Admin only — bypasses the chain entirely regardless of its current state. */
export function useOverrideTimeOffRequest() {
  const queryClient = useQueryClient();
  const orgId = useOrganizationStore((s) => s.activeOrganizationId)!;

  return useMutation({
    mutationFn: ({
      requestId,
      payload,
    }: {
      requestId: string;
      payload: OverrideTimeOffRequestPayload;
    }) => timeOffService.overrideRequest(requestId, payload),
    onSuccess: (_data, { requestId }) => {
      queryClient.invalidateQueries({ queryKey: TIME_OFF_KEYS.request(orgId, requestId) });
      queryClient.invalidateQueries({ queryKey: TIME_OFF_KEYS.approvals(orgId) });
      queryClient.invalidateQueries({ queryKey: ['time-off', 'team', orgId] });
      queryClient.invalidateQueries({ queryKey: ['time-off', 'admin'] });
    },
  });
}
